// import Services from '@/services/index';
// import VT from '@/store/types';

export default {
  // [VT.AI_MODEL_DELETE]: ({}, id) => {
  //   return new Promise((resolve, reject) => {
  //     Services.aiModels.delete(id).then((data) => {
  //       resolve(data);
  //     }).catch((data) => {
  //       reject(data);
  //     });
  //   });
  // },
};
